import { dispatchInitiatorExecution } from "./dispatchInitiatorExecution.js";
import { MEMORIZE_JQUERY_EVENT_PROPERTY } from "./memorizeJQueryEvent.js";
import { MEMORIZE_NATIVE_EVENT_PROPERTY } from "./memorizeNativeEvent.js";
import { isCurrentlyInTransaction } from "../../checker/transaction.js";
import { OPT_IN_CONTENT_BLOCKER_ALL } from "../../events/optInContentBlockerAll.js";
const OVERWRITE_PROPERTY = "rcbJQueryEventListener";
/**
 * Overwrite `jQuery(selector).on` and `jQuery.event.add` for special events
 * like `elementor/frontend/init`.
 */ function applyJQueryEventInitiator(doc, element, eventName, { onBeforeExecute, isLoad } = {
    onBeforeExecute: undefined,
    isLoad: false
}) {
    const overwriteProp = `${OVERWRITE_PROPERTY}_${eventName}`;
    const memorizeProp = `${MEMORIZE_JQUERY_EVENT_PROPERTY}_${eventName}`;
    const memorizeNativeProp = `${MEMORIZE_NATIVE_EVENT_PROPERTY}_${eventName}`;
    const { jQuery } = doc.defaultView || doc.parentWindow;
    if (!jQuery) {
        return;
    }
    const { event, Event } = jQuery;
    if (!event || !Event || event[overwriteProp]) {
        return;
    }
    const { add } = event;
    Object.assign(event, {
        [overwriteProp]: true,
        add: function(...args) {
            // https://git.io/JsXSb
            const [elem, types, handler, data, selector] = args;
            const useTypes = Array.isArray(types) ? types : typeof types === "string" ? types.split(" ") : types;
            const memorizeExecutionPromise = event[memorizeProp] || elem[memorizeNativeProp]?.then(()=>[]);
            const inTransaction = isCurrentlyInTransaction();
            // Redirect to own thread to avoid variable order lacks (e. g. Uncode Gmaps Integration, Contact Form 7)
            const executeHandle = ([, ...eventParameters] = [])=>setTimeout(()=>{
                    const afterExecution = dispatchInitiatorExecution({
                        type: "jQueryEvent",
                        elem,
                        types,
                        handler,
                        data,
                        selector
                    });
                    onBeforeExecute?.(inTransaction);
                    handler?.(new Event(), ...eventParameters);
                    afterExecution();
                }, 0);
            if (types && elem === element) {
                for (const type of useTypes){
                    const isRequestedEventName = type === eventName;
                    if (isRequestedEventName && inTransaction) {
                        document.addEventListener(OPT_IN_CONTENT_BLOCKER_ALL, ({ detail: { load } })=>{
                            if (memorizeExecutionPromise) {
                                memorizeExecutionPromise.then(executeHandle);
                            } else if (isLoad) {
                                load.then(executeHandle);
                            } else {
                                executeHandle();
                            }
                        }, {
                            once: true
                        });
                    } else if (isRequestedEventName && memorizeExecutionPromise) {
                        memorizeExecutionPromise.then(executeHandle);
                    } else {
                        add.apply(this, [
                            elem,
                            type,
                            handler,
                            data,
                            selector
                        ]);
                    }
                }
            } else {
                add.apply(this, args);
            }
        }
    });
}
export { applyJQueryEventInitiator };
